var React = require('react');

function Close (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"currentColor","d":"M10.561 5.322 15.482.296l1.43 1.399-4.921 5.027-1.43-1.4zm-1.78 4.6 6.807 6.782L17 15.287 1.973.313.562 1.73l6.803 6.78-6.779 6.778L2 16.703 8.782 9.92z"}));
}

Close.defaultProps = {"fill":"none","viewBox":"0 0 17 17","version":"1.1","x":"0px","y":"0px"};

module.exports = Close;

Close.default = Close;
